import Config from '@skin_config';

const checkRouteConfig = (ticketsCount) => ({
  tickets: () => ticketsCount > 1 && Config.main.ticketAvailableViewMode.includes('card') && Config.tickets.enableMultipleTickets,
});

export default checkRouteConfig;
